<template>
    <!-- eslint-disable -->
    <MainContainer>
        <template v-slot:sidebar>&nbsp;</template>
        <div class="anwesenheitsverwaltung">
            <section>
                <h2>Anwesenheitsverwaltung</h2>
                <b-form>
                    <b-form-group
                        label="Stimme"
                        label-for="singer"
                        :label-size="size"
                    >
                        <b-select
                            id="singer"
                            :size="size"
                            :options="singer.options"
                            v-model="filter.singer"
                        ></b-select>
                    </b-form-group>
                    <b-form-group
                        label="Werk"
                        label-for="werk"
                        :label-size="size"
                    >
                        <b-select
                            id="werk"
                            :size="size"
                            :options="werke.options"
                            v-model="filter.werke"
                            :disabled="werke.busy"
                        ></b-select>
                    </b-form-group>
                    <b-button
                        :size="size"
                        @click="selectFilter"
                        :disabled="!validFilter || busy"
                        variant="primary"
                        >Anzeigen</b-button
                    >
                    <b-button
                        v-if="checkRight('write')"
                        :size="size"
                        @click="downloadList"
                        :disabled="!validFilter || busyPrinting"
                        class="ml-1"
                        variant="outline-primary"
                    >
                        <template v-if="busyPrinting">
                            <Spinner small variant="primary" class="mr-1" />
                        </template>
                        <template v-else>
                            <font-awesome-icon
                                icon="print"
                                class="mr-1"
                            /> </template
                        >Liste drucken
                    </b-button>
                    <b-button
                        v-if="checkRight('write')"
                        :size="size"
                        @click="downloadFreikarten"
                        :disabled="!validFilter || busyPrinting"
                        class="ml-1"
                        variant="outline-primary"
                    >
                        <template v-if="busyPrinting">
                            <Spinner small variant="primary" class="mr-1" />
                        </template>
                        <template v-else>
                            <font-awesome-icon
                                icon="print"
                                class="mr-1"
                            /> </template
                        >Freikartenliste drucken
                    </b-button>
                    <b-button
                        :size="size"
                        @click="resetFilter"
                        class="ml-1"
                        variant="outline-danger"
                        >Zurücksetzen</b-button
                    >
                </b-form>
            </section>
            <hr />
            <section v-if="items.length > 0 || itemsExcluded.length > 0">
                <article>
                    <h5>
                        Mitglieder mit Beteiligung am Werk
                        <b-button v-b-toggle.includedItems size="sm"
                            >{{ includedVisible ? 'Ausblenden' : 'Einblenden' }}</b-button
                        >
                    </h5>
                    <b-collapse id="includedItems" v-model="includedVisible">
                        <Table
                            bordered
                            striped
                            showFilter
                            footer
                            :stickyHeader="false"
                            :responsive="true"
                            :fields="fields"
                            :items="items"
                            :isBusy="busy"
                            busyText="Lädt Anwesenheitsdaten..."
                            emptyText="Keine Anwesenheitsdaten gefunden"
                        >
                            <template
                                v-for="col in fields"
                                v-slot:[headConstraint(col.key)]="{
                                        row: row
                                    }"
                            >
                                <div
                                    :key="col.key"
                                    class="custom-table-head-container"
                                >
                                    <template v-if="row.field.isClickable">
                                        <p>
                                            {{
                                                $moment(
                                                    row.field._info.datum
                                                ).format("DD.MM.Y")
                                            }}
                                        </p>
                                        <p class="small">
                                            {{
                                                "<" +
                                                getProbentypProp(
                                                    row.field._info
                                                        .pkTyp,
                                                    "kuerzel"
                                                ) +
                                                ">"
                                            }}
                                        </p>
                                        <p class="small">
                                            {{ getVoiceShortcuts(row) }}
                                        </p>
                                        <p class="small">
                                            {{ row.field._info.info }}
                                        </p>
                                        <template
                                            v-if="
                                                    $moment(
                                                        row.field._info.datum
                                                    ).isBefore()
                                                "
                                        >
                                            <hr />
                                            <TrueFalseSwitch
                                                v-if="checkRight('write')"
                                                :plain="true"
                                                @true="
                                                        addAll(row.field.key)
                                                    "
                                                @false="
                                                        removeAll(row.field.key)
                                                    "
                                            />
                                        </template>
                                    </template>
                                    <template v-else>
                                        {{ row.label }}
                                    </template>
                                </div>
                            </template>

                            <template
                                v-for="col in fields"
                                v-slot:[col.key]="{ row: row }"
                            >
                                <template v-if="row.field.isClickable">
                                    <template
                                        v-if="
                                                $moment(
                                                    row.field._info.datum
                                                ).isBefore()
                                            "
                                    >
                                        <div :key="col.key">
                                            <TrueFalseSwitch
                                                v-if="checkRight('write')"
                                                :state="isAvailable(row)"
                                                :busy="
                                                        row.item.busy ||
                                                            busyMassUpdating
                                                    "
                                                @true="addProbe(row)"
                                                @false="removeProbe(row)"
                                            />
                                        </div>
                                    </template>
                                    <template v-else-if="isAvailable(row)">
                                            <span class="small text-secondary"
                                            >Zukünftiger Termin
                                                vorbelegt</span
                                            >
                                    </template>
                                    <template v-else>
                                        &nbsp;
                                    </template>
                                </template>
                            </template>

                            <template v-slot:mitglied_guest="{ row: row }">
                                <template v-if="row.value">G</template>
                                <template v-else>-</template>
                            </template>

                            <template
                                v-slot:head(pflichtproben)="{ row: row }"
                            >
                                <div class="custom-table-head-container">
                                    <p>{{ row.label }}</p>
                                    <p class="small">teilgenommen</p>
                                    <p class="small text-secondary">
                                        benötigt (bis heute)
                                    </p>
                                    <p class="small text-success">
                                        Anteil
                                    </p>
                                </div>
                            </template>

                            <template
                                v-slot:head(pflichtkonzerte)="{ row: row }"
                            >
                                <div class="custom-table-head-container">
                                    <p>{{ row.label }}</p>
                                    <p class="small">teilgenommen</p>
                                    <p class="small text-secondary">
                                        benötigt (bis heute)
                                    </p>
                                    <p class="small text-success">
                                        Anteil
                                    </p>
                                </div>
                            </template>

                            <template v-slot:pflichtproben="{ row: row }">
                                <Pflichtproben
                                    :data="row.item"
                                    prefix="probe"
                                />
                            </template>

                            <template v-slot:pflichtkonzerte="{ row: row }">
                                <Pflichtproben
                                    :data="row.item"
                                    prefix="konzert"
                                />
                            </template>

                            <template v-slot:foot()="{ data: data }">
                                <template
                                    v-if="
                                            data.field.isClickable &&
                                                $moment(
                                                    data.field._info.datum
                                                ).isBefore()
                                        "
                                >
                                    <TrueFalseSwitch
                                        v-if="checkRight('write')"
                                        :plain="true"
                                        @true="addAll(data.field.key)"
                                        @false="removeAll(data.field.key)"
                                    />
                                </template>
                                <template v-else>&nbsp;</template>
                            </template>
                        </Table>
                    </b-collapse>
                </article>
                <hr />
                <article>
                    <h5>
                        Mitglieder ohne Konzertbeteiligung
                        <b-button v-b-toggle.excludedItems size="sm"
                            >{{ excludedVisible ? 'Ausblenden' : 'Einblenden' }}</b-button
                        >
                    </h5>
                    <b-collapse id="excludedItems" v-model="excludedVisible" @shown="focusExcluded">
                        <Table
                            bordered
                            striped
                            showFilter
                            :responsive="true"
                            :stickyHeader="false"
                            :fields="fields"
                            :items="itemsExcluded"
                            :isBusy="busyExcluded"
                            busyText="Lädt Anwesenheitsdaten..."
                            emptyText="Keine Anwesenheitsdaten gefunden"
                            ref="excluded"
                        >
                            <template
                                v-for="col in fields"
                                v-slot:[headConstraint(col.key)]="{
                                        row: row
                                    }"
                            >
                                <div
                                    :key="col.key"
                                    class="custom-table-head-container"
                                >
                                    <template v-if="row.field.isClickable">
                                        <p>
                                            {{
                                                $moment(
                                                    row.field._info.datum
                                                ).format("DD.MM.Y")
                                            }}
                                        </p>
                                        <p class="small">
                                            {{
                                                "<" +
                                                getProbentypProp(
                                                    row.field._info
                                                        .pkTyp,
                                                    "kuerzel"
                                                ) +
                                                ">"
                                            }}
                                        </p>
                                        <p class="small">
                                            {{ getVoiceShortcuts(row) }}
                                        </p>
                                        <p class="small">
                                            {{ row.field._info.info }}
                                        </p>
                                    </template>
                                    <template v-else>
                                        {{ row.label }}
                                    </template>
                                </div>
                            </template>

                            <template
                                v-for="col in fields"
                                v-slot:[col.key]="{ row: row }"
                            >
                                <template v-if="row.field.isClickable">
                                    <template
                                        v-if="
                                                $moment(
                                                    row.field._info.datum
                                                ).isBefore()
                                            "
                                    >
                                        <div :key="col.key">
                                            <TrueFalseSwitch
                                                v-if="checkRight('write')"
                                                :state="isAvailable(row)"
                                                :busy="row.item.busy"
                                                @true="addProbe(row, true)"
                                                @false="
                                                        removeProbe(row, true)
                                                    "
                                            /></div
                                        ></template>
                                    <template v-else-if="isAvailable(row)">
                                            <span class="small text-secondary"
                                            >Zukünftiger Termin
                                                vorbelegt</span
                                            >
                                    </template>
                                    <template v-else>
                                        &nbsp;
                                    </template>
                                </template>
                            </template>

                            <template v-slot:mitglied_guest="{ row: row }">
                                <template v-if="row.value">G</template>
                                <template v-else>-</template>
                            </template>

                            <template
                                v-slot:head(pflichtproben)="{ row: row }"
                            >
                                <div class="custom-table-head-container">
                                    <p>{{ row.label }}</p>
                                    <p class="small">teilgenommen</p>
                                    <p class="small text-secondary">
                                        benötigt (bis heute)
                                    </p>
                                    <p class="small text-success">
                                        Anteil
                                    </p>
                                </div>
                            </template>

                            <template
                                v-slot:head(pflichtkonzerte)="{ row: row }"
                            >
                                <div class="custom-table-head-container">
                                    <p>{{ row.label }}</p>
                                    <p class="small">teilgenommen</p>
                                    <p class="small text-secondary">
                                        benötigt (bis heute)
                                    </p>
                                    <p class="small text-success">
                                        Anteil
                                    </p>
                                </div>
                            </template>

                            <template v-slot:pflichtproben="{ row: row }">
                                <Pflichtproben
                                    :data="row.item"
                                    prefix="probe"
                                />
                            </template>

                            <template v-slot:pflichtkonzerte="{ row: row }">
                                <Pflichtproben
                                    :data="row.item"
                                    prefix="konzert"
                                />
                            </template>
                        </Table>
                    </b-collapse>
                </article>
            </section>
            <section v-else>
                <template v-if="busy || busyExcluded">
                    <CenteredMessage :spinner="true">
                        <template #title>Daten werden geladen</template>
                    </CenteredMessage>
                </template>
                <template v-else>
                    <CenteredMessage>
                        <template #title>Keine Daten vorhanden</template>
                        <template
                            >Bitte zuerst entsprechende Filter
                            auswählen</template
                        >
                    </CenteredMessage>
                </template>
            </section>
        </div>
    </MainContainer>
</template>

<script>
/* eslint-disable */
import Size from "@/mixins/Size/Size";
import Rights from "@/mixins/Rights/Rights";
import { ApiFactory } from "@/api/ApiFactory.js";
import { BlobUtil } from "@/utils/BlobUtil";
import MainContainer from "@/components/MainContainer/MainContainer";
import Table from "@/components/Table/Table";
import EditModal from "@/components/EditModal/EditModal";
import RemoveModal from "@/components/RemoveModal/RemoveModal";
import FormGroupBuilder from "@/components/FormGroupBuilder/FormGroupBuilder";
import CenteredMessage from "@/components/CenteredMessage/CenteredMessage";
import TrueFalseSwitch from "@/components/TrueFalseSwitch/TrueFalseSwitch";
import Pflichtproben from "@/components/Pflichtproben/Pflichtproben";
import Spinner from "@/components/Spinner/Spinner";

import "./Anwesenheitsverwaltung.scss";

const AnwesenheitsverwaltungApi = ApiFactory.get("anwesenheitsverwaltung");
const WerkeApi = ApiFactory.get("werke");
const ProbentypApi = ApiFactory.get("probentyp");

export default {
    name: "AnwesenheitsverwaltungNeu",
    mixins: [Size, Rights],
    components: {
        MainContainer,
        Table,
        EditModal,
        RemoveModal,
        FormGroupBuilder,
        CenteredMessage,
        TrueFalseSwitch,
        Pflichtproben,
        Spinner
    },
    data() {
        return {
            filter: {
                singer: null,
                werke: null
            },
            fields: [],
            singer: {
                options: [
                    {
                        value: null,
                        text: "Stimme auswählen..."
                    },
                    {
                        value: "sopran",
                        text: "Sopran"
                    },
                    {
                        value: "alt",
                        text: "Alt"
                    },
                    {
                        value: "tenor",
                        text: "Tenor"
                    },
                    {
                        value: "bass",
                        text: "Bass"
                    }
                ]
            },
            werke: {
                busy: false,
                options: [
                    {
                        value: null,
                        text: "Werk auswählen..."
                    }
                ]
            },
            probentyp: {
                busy: false,
                items: []
            },
            includedVisible: true,
            excludedVisible: true,
            items: [],
            itemsExcluded: [],
            busy: false,
            busyMassUpdating: false,
            busyExcluded: false,
            busyPrinting: false,
        };
    },
    computed: {
        storedFilter() {
            const pages = this.$store.getters.getPages;
            if (pages.anwesenheitsverwaltung_neu) {
                return pages.anwesenheitsverwaltung_neu.filter;
            } else {
                return this.filter;
            }
        },
        validFilter() {
            return this.filter.singer !== null && this.filter.werke !== null;
        }
    },
    async created() {
        this.filter = { ...this.storedFilter };
        this.fetchProbentyp();
        await this.fetchWerke();
    },
    methods: {
        async fetch(excluded = false) {
            if (excluded) {
                this.busyExcluded = true;
            } else {
                this.busy = true;
            }
            if (this.validFilter) {
                const response = excluded
                    ? await AnwesenheitsverwaltungApi.getExcluded(
                          this.filter.werke,
                          this.filter.singer
                      )
                    : await AnwesenheitsverwaltungApi.get_new(
                          this.filter.werke,
                          this.filter.singer
                      );
                if (response.ok) {
                    const probenplan = response.json.probenplan;
                    var fields = [
                        {
                            key: "mitglied",
                            label: "Name",
                            stickyColumn: true,
                            class: "name table-light b-table-sticky-column"
                        },
                        {
                            key: "mitglied_guest",
                            label: "G",
                            stickyColumn: true,
                            class: "text-center"
                        }
                    ];
                    fields = fields.concat(
                        probenplan.map(probe => {
                            var variant =
                                this.getProbentypProp(probe.pk_typ, "klasse") ==
                                "2"
                                    ? "success"
                                    : "";
                            return {
                                key: String(probe.id),
                                label: probe.datum,
                                _info: {
                                    id: probe.id,
                                    datum: probe.datum,
                                    pkTyp: probe.pk_typ,
                                    info: probe.info,
                                    sopran: probe.sopran,
                                    alt: probe.alt,
                                    tenor: probe.tenor,
                                    bass: probe.bass
                                },
                                variant: variant,
                                isClickable: true,
                                class: "text-center"
                            };
                        })
                    );
                    fields = fields.concat([
                        {
                            key: "pflichtproben",
                            label: "Proben",
                            class: "text-center",
                            tdClass: "probe",
                            thClass: "probe"
                        },
                        {
                            key: "pflichtkonzerte",
                            label: "Konzerte",
                            class: "text-center",
                            tdClass: "probe",
                            thClass: "probe"
                        }
                    ]);

                    this.fields = fields;

                    const mitglieder = response.json.mitglieder;
                    const items = mitglieder.map(mitglied => {
                        return this.process(mitglied);
                    });

                    if (excluded) {
                        this.itemsExcluded = items;
                    } else {
                        this.items = items;
                    }
                }
                this.registerRights(response);
            }
            if (excluded) {
                this.busyExcluded = false;
            } else {
                this.busy = false;
            }
            this.isLoaded = true;
        },
        async fetchWerke() {
            this.werke.busy = true;
            this.werke.options = [
                { value: null, text: "Werke werden geladen..." }
            ];
            this.filter.werke = null;

            const response = await WerkeApi.get();
            if (response.ok) {
                const data = response.json.collection;

                var options = [{ value: null, text: "Werk auswählen..." }];
                options = options.concat(
                    data.map(item => {
                        return {
                            value: item.id,
                            text:
                                item.bezeichnung +
                                " - " +
                                this.$moment(item.verfallsdatum)
                                    .subtract("1", "day")
                                    .format("DD.MM.Y")
                        };
                    })
                );
                this.werke.options = options;

                if (this.storedFilter.werke) {
                    this.filter.werke = this.storedFilter.werke;
                }
            }
            this.werke.busy = false;
        },
        async fetchProbentyp() {
            this.probentyp.busy = true;
            const response = await ProbentypApi.get();
            if (response.ok) {
                this.probentyp.items = response.json.collection;
            }
            this.probentyp.busy = false;
        },
        process(mitglied) {
            var row = {
                mitglied_id: mitglied.id,
                mitglied: mitglied.name + ", " + mitglied.vorname,
                mitglied_status: mitglied.status,
                mitglied_guest: mitglied.guest
            };
            for (const date of mitglied.anwesenheit) {
                row[date.termin_id] = date;
            }
            row = Object.assign(row, {
                probe_active: mitglied.pflicht_proben.active,
                probe_until_now: mitglied.pflicht_proben.until_now_share,
                probe_diff: mitglied.pflicht_proben.diff,
                konzert_active: mitglied.pflicht_konzert.active,
                konzert_until_now: mitglied.pflicht_konzert.until_now_share,
                konzert_diff: mitglied.pflicht_konzert.diff,
                busy: false
            });
            return row;
        },
        selectFilter() {
            const filter = { ...this.filter };
            this.$store.dispatch("pages", {
                anwesenheitsverwaltung_neu: {
                    filter: filter
                }
            });

            this.fetch();
            this.fetch(true);
        },
        resetFilter() {
            const filter = {
                singer: null,
                werke: null
            };
            this.$store.dispatch("pages", {
                anwesenheitsverwaltung_neu: {
                    filter: filter
                }
            });
            this.filter = filter;
        },
        headConstraint(key) {
            return `head(${key})`;
        },
        parseProbenCounter(col) {
            if (
                this.filter.singer === "sopran" ||
                this.filter.singer === "alt"
            ) {
                return col.field._info.counterDa;
            } else {
                return col.field._info.counterHe;
            }
        },
        isAvailable(row) {
            if (row.value.id) {
                return true;
            } else {
                if (
                    this.$moment(row.field._info.datum).diff(
                        this.$moment(),
                        "days"
                    ) < 0
                ) {
                    return false;
                } else {
                    return null;
                }
            }
        },
        async addProbe(row, excluded = false) {
            if (this.checkRight("write")) {
                row.item.busy = true;
                const termin_id = row.field._info.id;
                const mitglied_id = row.item.mitglied_id;

                const response = await AnwesenheitsverwaltungApi.put(
                    termin_id,
                    mitglied_id
                );
                if (response.ok) {
                    const mitglied = response.json.mitglied;
                    const items = excluded
                        ? [...this.itemsExcluded]
                        : [...this.items];
                    const index = items.findIndex(
                        item => item.mitglied_id === mitglied_id
                    );
                    items[index] = this.process(mitglied);
                    if (excluded) {
                        this.itemsExcluded = items;
                    } else {
                        this.items = items;
                    }
                }
                row.item.busy = false;
            }
        },
        async removeProbe(row, excluded = false) {
            if (this.checkRight("delete")) {
                row.item.busy = true;
                const termin_id = row.field._info.id;
                const mitglied_id = row.item.mitglied_id;

                const response = await AnwesenheitsverwaltungApi.delete(
                    termin_id,
                    mitglied_id
                );
                if (response.ok) {
                    const mitglied = response.json.mitglied;
                    if (mitglied) {
                        const items = excluded
                            ? [...this.itemsExcluded]
                            : [...this.items];
                        const index = items.findIndex(
                            item => item.mitglied_id === mitglied_id
                        );
                        items[index] = this.process(mitglied);
                        if (excluded) {
                            this.itemsExcluded = items;
                        } else {
                            this.items = items;
                        }
                    }
                }
                row.item.busy = false;
            }
        },
        async addAll(termin_id) {
            this.busyMassUpdating = true;
            const response = await AnwesenheitsverwaltungApi.putAll(
                termin_id,
                this.filter.singer
            );
            if (response.ok) {
                var updatedItems = response.json.collection;
                updatedItems = updatedItems
                    .filter(mitglied => mitglied !== null)
                    .map(mitglied => {
                        return this.process(mitglied);
                    });
                var items = [...this.items];
                items = items.map(item => {
                    var updatedItem = updatedItems.find(
                        mitglied => item.mitglied_id === mitglied.mitglied_id
                    );
                    if (updatedItem) {
                        item = updatedItem;
                    }
                    return item;
                });

                this.items = items;
            }
            this.busyMassUpdating = false;
        },
        async removeAll(termin_id) {
            this.busyMassUpdating = true;
            const response = await AnwesenheitsverwaltungApi.deleteAll(
                termin_id,
                this.filter.singer
            );
            if (response.ok) {
                var updatedItems = response.json.collection;
                updatedItems = updatedItems
                    .filter(mitglied => mitglied !== null)
                    .map(mitglied => {
                        return this.process(mitglied);
                    });
                var items = [...this.items];
                items = items.map(item => {
                    var updatedItem = updatedItems.find(
                        mitglied => item.mitglied_id === mitglied.mitglied_id
                    );
                    if (updatedItem) {
                        item = updatedItem;
                    }
                    return item;
                });

                this.items = items;
            }
            this.busyMassUpdating = false;
        },
        async downloadList() {
            this.busyPrinting = true;
            const response = await AnwesenheitsverwaltungApi.print(
                this.filter.werke,
                this.filter.singer
            );
            if (response.ok) {
                BlobUtil.downloadBlob(response.blob, "Anwesenheitsliste.pdf");
            }
            this.busyPrinting = false;
        },
        async downloadFreikarten() {
            this.busyPrinting = true;
            const response = await AnwesenheitsverwaltungApi.freikarten(
                this.filter.werke,
                this.filter.singer
            );
            if (response.ok) {
                BlobUtil.downloadBlob(response.blob, "Freikartenliste.pdf");
            }
            this.busyPrinting = false;
        },
        getProbentypProp(probentypId, propName) {
            const probentyp = this.probentyp.items.find(item => {
                return item.id === probentypId;
            });
            if (probentyp) {
                return probentyp[propName];
            } else {
                return probentypId;
            }
        },
        getVoiceShortcuts(row) {
            var str = "";
            if (row.field._info.sopran) {
                str += "S";
            }
            if (row.field._info.alt) {
                str += "A";
            }
            if (row.field._info.tenor) {
                str += "T";
            }
            if (row.field._info.bass) {
                str += "B";
            }
            return str;
        },
        focusExcluded() {
            console.log(this.$refs.excluded)
            this.$refs.excluded.$el.scrollIntoView({ behavior: "smooth"});
        }
    },
};
</script>
